import PromoResults from "./PromoResults";

export default PromoResults;
